<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    :closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test70" />
      <h2>{{ $t('message["501"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="!len">
          <p> {{ tip }} </p>
          <a-button
            type="primary"
            class="allot-btn"
            @click="closeHandle"
          >
            {{ $t('message["401"]') }}
          </a-button>
        </template>
        <template v-else>
          <p> {{ tip }} </p>

          <p
            v-if="this.$route.query.scope === 'clue'"
            class="allot-more"
          >
            仍有{{ len }}条线索未完成交接
          </p>
          <p
            v-else
            class="allot-more"
          >
            {{ successTip[0] }}{{ len }}{{ successTip[1] }}。
          </p>
          <a-button
            type="primary"
            class="allot-btn"
            @click="continueHandle"
          >
            {{ $t('message["466"]') }}
          </a-button>
        </template>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  props: {
    inquryid: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    ...mapState('quit', ['quitListDatas', 'quitName', 'pagination']),
    len () {
      const { data = {} } = this.quitListDatas
      const count = data ? data.count : 0
      return count - this.inquryid.length
    },
    tit () {
      const type = this.$route.query.scope
      let title = this.$t('message["372"]')
      switch (type) {
        case 'dev' :
          title = this.$t('message["547"]')
          break
        case 'follow' :
          title = this.$t('message["372"]')
          break
        case 'input' :
          title = this.$t('message["617"]')
          break
        // case 'clue' :
        //   title = '跟进线索'
        //   break
        default :
          title = this.$t('message["1045"]')
      }
      return title
    },
    filterDatas () {
      const { filterarr = [] } = this.$route.query
      let obj = {}
      filterarr.forEach(item => {
        const itemObj = { [item.fieldkey]: item.fieldvalue }
        obj = Object.assign(obj, itemObj)
      })
      return obj
    },
    tip () {
      const langType = this.getLang()
      const { length = 0 } = this.inquryid
      const { truename = '' } = this.quitName
      const { tit } = this
      const type = this.$route.query.scope
      if (langType === 'en') {
        return `${length} inquires of ${truename} who ${tit} has been transfered.`
      } else {
        return `此次共交接${truename}${type === 'clue' ? '' : tit}${type === 'clue' ? '跟进的线索' : '的信息'}${length}条。`
      }
    },
    successTip () {
      return this.$t('message["940"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('quit', ['getPeronListsDatas']),
    getLang,
    changeVisible (b) {
      this.TipDialogVisible = b
    },
    async continueHandle () {
      this.TipDialogVisible = false
      const { scope = 'clue' } = this.$route.query
      const chain = await this.getPeronListsDatas({ isFilter: false, isClue: scope === 'clue' })
      chain.params({ userid: this.quitName.userid, scope: scope, search: this.filterDatas, limit: this.$route.query.limit })
        .onSuccess(raw => {
          this.pagination.currentPage = 1
        })
        .fetch()
    },
    closeHandle () {
      this.TipDialogVisible = false
      location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.allot-more {
  color: #F6A953;
}
.allot-btn {
  margin-top: 16px;
}
</style>
